const missingImageSvg = `
    <svg width="328" height="185" viewBox="0 0 328 185" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_8100_40932)">
    <g clip-path="url(#clip1_8100_40932)">
    <mask id="mask0_8100_40932" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="328" height="185">
    <path d="M328 0H0.000488281V185H328V0Z" fill="white"/>
    </mask>
    <g mask="url(#mask0_8100_40932)">
    <path d="M0.000488281 185V0H328V185H0.000488281Z" fill="url(#paint0_linear_8100_40932)"/>
    <path d="M284.9 165.9C284.9 171.7 282.2 176.7 278.8 176.7C275.4 176.7 272.7 171.4 272.7 165.9C272.7 158.6 278.8 150.9 278.8 150.9C278.8 150.9 284.9 158 284.9 165.9Z" fill="#CDCDD0"/>
    <path d="M279 176.7H278.5V184.4H279V176.7Z" fill="#CDCDD0"/>
    <path d="M294.2 165.9C294.2 171.7 291.5 176.7 288.1 176.7C284.7 176.7 282 171.4 282 165.9C282 158.6 288.1 150.9 288.1 150.9C288.1 150.9 294.2 158 294.2 165.9Z" fill="white"/>
    <path d="M288.3 176.7H287.8V184.4H288.3V176.7Z" fill="white"/>
    <path d="M313 160.4C313 167.9 309.5 174.4 305.1 174.4C300.7 174.4 297.2 167.5 297.2 160.4C297.2 150.9 305.1 140.9 305.1 140.9C305.1 140.9 313 150.1 313 160.4Z" fill="#CDCDD0"/>
    <path d="M305.4 174.4H304.7V184.3H305.4V174.4Z" fill="#CDCDD0"/>
    <path d="M280.5 69.6999C293.976 69.6999 304.9 58.7757 304.9 45.2999C304.9 31.8242 293.976 20.8999 280.5 20.8999C267.024 20.8999 256.1 31.8242 256.1 45.2999C256.1 58.7757 267.024 69.6999 280.5 69.6999Z" fill="#E0E0E0"/>
    <path d="M262.4 44.2997V44.1997C262.4 41.6997 260.4 39.6997 257.9 39.6997C255.7 39.6997 253.8 41.2997 253.5 43.3997C253.5 43.3997 251.5 43.3997 251.4 43.3997C250.6 43.3997 251.8 43.6997 251.2 44.1997C250.2 45.0997 250.8 46.6997 252.2 46.6997H262.5C263.5 46.6997 264.1 45.3997 263.3 44.6997C263 44.4997 262.7 44.3997 262.4 44.2997Z" fill="#F7F7F8"/>
    <path d="M316.4 63.5998C316.3 63.2998 316.2 62.9998 316.1 62.6998C315.6 61.4998 314.5 60.5998 313.2 60.2998C312.3 60.0998 311.5 60.1998 310.8 60.3998C309.6 58.8998 307.7 57.8998 305.6 57.8998C305.2 57.8998 304.8 57.8998 304.4 57.9998C302.8 55.1998 299.8 53.2998 296.4 53.2998C292.2 53.2998 288.6 56.0998 287.6 59.9998C286.8 59.7998 285.8 59.6998 284.9 60.0998C283.3 60.5998 282.1 61.9998 281.8 63.6998C281.6 64.7998 282.5 65.7998 283.7 65.7998H314.6C315.7 65.7998 316.6 64.7998 316.4 63.5998Z" fill="#F7F7F8"/>
    <path d="M62.0004 137.9C62.0004 137.9 36.4004 54.1998 -19.0996 125.9C-19.0996 125.9 -7.09961 159.2 21.5004 158.3C50.1004 157.4 62.0004 137.9 62.0004 137.9Z" fill="#E0E0E0"/>
    <path d="M17.3005 132.6H15.0005V184.7H17.3005V132.6Z" fill="#AEAEAE"/>
    <path d="M25.7588 132.081L15.0996 154.253L17.1726 155.25L27.8318 133.078L25.7588 132.081Z" fill="#AEAEAE"/>
    <path d="M33.2002 159.9C33.2002 159.9 46.7002 116 75.8002 153.6C75.8002 153.6 69.5002 171.1 54.5002 170.6C39.5002 170.1 33.2002 159.9 33.2002 159.9Z" fill="#C7C7C7"/>
    <path d="M57.9002 157.1H56.7002V184.4H57.9002V157.1Z" fill="#AEAEAE"/>
    <path d="M52.2402 156.879L51.1587 157.399L56.7483 169.026L57.8298 168.506L52.2402 156.879Z" fill="#AEAEAE"/>
    </g>
    </g>
    </g>
    <defs>
    <linearGradient id="paint0_linear_8100_40932" x1="164" y1="25.7897" x2="164" y2="174.767" gradientUnits="userSpaceOnUse">
    <stop stop-color="#F7F7F8"/>
    <stop offset="1" stop-color="#E2E2E4"/>
    </linearGradient>
    <clipPath id="clip0_8100_40932">
    <rect width="328" height="184.5" fill="white" transform="translate(0.000488281)"/>
    </clipPath>
    <clipPath id="clip1_8100_40932">
    <rect width="328" height="185" fill="white" transform="translate(0.000488281)"/>
    </clipPath>
    </defs>
    </svg>
`;
const errorImageSvg = `
    <svg width="328" height="185" viewBox="0 0 328 185" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_8100_41001)">
    <g clip-path="url(#clip1_8100_41001)">
    <path d="M0 185V0H328V185H0Z" fill="url(#paint0_linear_8100_41001)"/>
    <path d="M173.959 63.1122L141.507 67.1343L145.529 99.5858L177.981 95.5637L173.959 63.1122Z" fill="#C7C7C7"/>
    <mask id="mask0_8100_41001" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="162" y="59" width="25" height="37">
    <path d="M181.8 59.3999H162.8L170.9 69.5999L162.8 75.9999L171.1 83.3999L162.8 95.7999H186.5V59.3999H181.8Z" fill="white"/>
    </mask>
    <g mask="url(#mask0_8100_41001)">
    <path d="M180.9 61.3999H148.2V94.0999H180.9V61.3999Z" fill="#F7F7F8"/>
    <path d="M177.1 64.8999H152.3V87.1999H177.1V64.8999Z" fill="white"/>
    <path d="M153.5 85.3998H175.5V70.7998L165.3 80.9998L160.5 75.9998L153.5 85.3998Z" fill="#E0E0E0"/>
    </g>
    <mask id="mask1_8100_41001" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="143" y="61" width="26" height="36">
    <path d="M169 82.7998L160 76.4998L167.1 69.1998L159.8 61.7998L143.7 63.7998L147.7 96.0998L163.4 94.0998L169 82.7998Z" fill="white"/>
    </mask>
    <g mask="url(#mask1_8100_41001)">
    <path d="M176.162 59.8085L143.71 63.8306L147.733 96.282L180.184 92.2599L176.162 59.8085Z" fill="#F7F7F8"/>
    <path d="M172.739 63.7572L148.128 66.8076L150.871 88.9381L175.482 85.8877L172.739 63.7572Z" fill="white"/>
    <path d="M151.9 86.9998L173.7 84.1998L171.9 69.7998L163 81.1998L157.7 76.7998L151.9 86.9998Z" fill="#E0E0E0"/>
    <path d="M153.6 74.0995C155.422 74.0995 156.9 72.6221 156.9 70.7995C156.9 68.977 155.422 67.4995 153.6 67.4995C151.777 67.4995 150.3 68.977 150.3 70.7995C150.3 72.6221 151.777 74.0995 153.6 74.0995Z" fill="#E0E0E0"/>
    </g>
    </g>
    </g>
    <defs>
    <linearGradient id="paint0_linear_8100_41001" x1="164" y1="25.7897" x2="164" y2="174.767" gradientUnits="userSpaceOnUse">
    <stop stop-color="#F7F7F8"/>
    <stop offset="1" stop-color="#E2E2E4"/>
    </linearGradient>
    <clipPath id="clip0_8100_41001">
    <rect width="328" height="184.5" fill="white"/>
    </clipPath>
    <clipPath id="clip1_8100_41001">
    <rect width="328" height="185" fill="white"/>
    </clipPath>
    </defs>
    </svg>
`;
const PLACEHOLDER_IMG_TYPE = "image/svg+xml";
const noImageSrc = URL.createObjectURL(new Blob([missingImageSvg], { type: PLACEHOLDER_IMG_TYPE }));
const onErrorImageSrc = URL.createObjectURL(new Blob([errorImageSvg], { type: PLACEHOLDER_IMG_TYPE }));
export const placeholders = {
    noImageSrc,
    onErrorImageSrc,
};
